// Wire contract Platform ↔ Data (R.8, AB.7). Semver: thêm trường tuỳ chọn = minor; đổi / bỏ = major (N-1 trong 90 ngày).
import { IsoDateTime, success, Uuid } from "@secretaa/http-contract";
import { z } from "zod";
export * as capabilities from "./capabilities.ts";
export * as appPackages from "./app-package.ts";
export * as supportProfiles from "./support-profile.ts";
export * as releaseManifests from "./release-manifest.ts";
export * as uiRuntimeReleases from "./ui-runtime-release.ts";
export * as modelRoutingApi from "./model-routing-api.ts";
export * as modelRoutingEvidence from "./model-routing-evidence.ts";
export * as modelRegistry from "./model-registry.ts";
export * as modelQuotaApi from "./model-quota-api.ts";
export * as aiQuotas from "./ai-quota.ts";

export const CONTRACT_VERSION = "1.2.0" as const;

/** ADR-010: vai trò project — trục riêng với vai trò workspace. */
export const ProjectRole = z.enum(["viewer", "editor", "manager"]);
export type ProjectRole = z.infer<typeof ProjectRole>;
/** ADR-010 mục 3: owner / admin ⇒ ALL; member ⇒ đúng các project được cấp. `scopeIds` = gốc các cây con được phép. */
export const ProjectAccess = z.discriminatedUnion("mode", [
  z.object({ mode: z.literal("ALL") }).strict(),
  z
    .object({
      mode: z.literal("SET"),
      projects: z.array(z.object({ projectId: Uuid, role: ProjectRole, scopeIds: z.array(Uuid).min(1).max(50).optional() }).strict()),
    })
    .strict(),
]);
export type ProjectAccess = z.infer<typeof ProjectAccess>;

/** Data chỉ được nói « tôi cần scope canonical của subject X trong workspace Y » — KHÔNG gửi role / quyền (A08). */
export const AccessScopeRequest = z
  .object({ subjectId: Uuid, workspaceId: Uuid, sessionId: Uuid, authEpoch: z.number().int().positive(), requestId: z.string().max(128) })
  .strict();
export type AccessScopeRequest = z.infer<typeof AccessScopeRequest>;

export const AccessScope = z
  .object({
    workspaceId: Uuid,
    subjectId: Uuid,
    scopeVersion: z.number().int().nonnegative(),
    membership: z.literal("active"),
    workspaceRole: z.enum(["owner", "admin", "member"]),
    orgScope: z.enum(["all", "restricted"]),
    accessibleUnitIds: z.array(Uuid),
    archivedUnitIds: z.array(Uuid),
    assignableUnitIds: z.array(Uuid),
    // 1.1.0 — tuỳ chọn trong giai đoạn rollout R1–R5 (ADR-010 mục 6): data-api ở chế độ shadow chịu được thiếu field;
    // chế độ enforce coi thiếu là từ chối (fail closed). Bắt buộc lại sau R6.
    projectAccess: ProjectAccess.optional(),
    computedAt: IsoDateTime,
  })
  .strict();
export type AccessScope = z.infer<typeof AccessScope>;
export const AccessScopeResponse = success(AccessScope);

export const TenantLocator = z
  .object({ workspaceId: Uuid, status: z.enum(["active", "suspended", "archived"]), customerDataRef: z.string(), dataRegion: z.string() })
  .strict();
export type TenantLocator = z.infer<typeof TenantLocator>;
export const TenantLocatorResponse = success(TenantLocator);

export const INTERNAL_PATHS = {
  accessScope: "/internal/v1/authz/access-scope",
  tenantLocator: (workspaceId: string) => `/internal/v1/tenant-data-locator/${workspaceId}`,
} as const;

export * as maintenanceTenants from "./maintenance-tenants.ts";

export * as capabilityPlanning from "./capability-planning.ts";
